/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RecommendedInputs */

const en_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(recommended)`)
};

const es_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(recomendado)`)
};

const fr_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(recommandé)`)
};

const de_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(empfohlen)`)
};

const ja_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(推奨)`)
};

const zh_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(推荐)`)
};

const ar_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(موصى به)`)
};

const id_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(disarankan)`)
};

const it_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(consigliato)`)
};

const ru_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(рекомендуется)`)
};

const pt_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(recomendado)`)
};

const ko_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(권장)`)
};

/**
* | output |
* | --- |
* | "(recommended)" |
*
* @param {RecommendedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const recommended = /** @type {((inputs?: RecommendedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RecommendedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recommended(inputs)
	if (locale === "es") return es_recommended(inputs)
	if (locale === "fr") return fr_recommended(inputs)
	if (locale === "de") return de_recommended(inputs)
	if (locale === "ja") return ja_recommended(inputs)
	if (locale === "zh") return zh_recommended(inputs)
	if (locale === "ar") return ar_recommended(inputs)
	if (locale === "id") return id_recommended(inputs)
	if (locale === "it") return it_recommended(inputs)
	if (locale === "ru") return ru_recommended(inputs)
	if (locale === "pt") return pt_recommended(inputs)
	return ko_recommended(inputs)
});